import React from "react";
import {Link, withRouter} from "react-router-dom";
import _CategoryMenu from "./_CategoryMenu.scss";
import {connect} from "react-redux";
import {PropTypes} from 'prop-types';

const defaultIcon = "fa fa-share";

class CategoryMenu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      categories: this.props.categories,
      toggeled: false
    };
  }

  toggleCategoryMenu() {
    this.setState({
      toggeled: !this.state.toggeled
    }, () => {
      if (this.state.toggeled == false) {
        let listItem = document.getElementsByClassName('has-submenu opened') || [];
        if (listItem.length > 0) {
          for (let i = 0; i < listItem.length; i++) {
            listItem[i].classList.remove("opened");
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      categories: nextProps.categories
    });
  }

  clickSubmenu(id) {
    let elem = document.getElementById(id);
    let listItem = document.getElementsByClassName('has-submenu opened') || [];
    if (listItem.length > 0 && listItem[0] != elem) {
      for (let i = 0; i < listItem.length; i++) {
        listItem[i].classList.remove("opened");
      }
    }
    elem.classList.toggle("opened");
  }

  render() {
    const categoryMenuClass = 'category-menu ' + (this.props.location.pathname.indexOf('/category') !== -1 ? 'category-page ' : '') + (this.state.toggeled ? 'opened' : '');
    return (
      <section className={categoryMenuClass}>
        <p className="title-category">Sản phẩm - dịch vụ</p>
        <div className="wrap-container-list-category">
          <div className="wrap-list-category">
            {
              this.state.categories.map((category, idx) => {
                if (idx < 12 || this.props.isShowAll) {
                  return (
                    <ul key={idx} id={`CategoryItem${idx}`} className={`category-menu-item ${category.children.length > 0 ? 'has-submenu' : ''}`}>
                      <li className="item" onClick={this.clickSubmenu.bind(this, `CategoryItem${idx}`)}>
                        <Link to={`/category/${category.id}`} className="item-link">
                          <i className={category.smallIcon ? category.smallIcon : defaultIcon}></i>
                          {category.name}
                        </Link>
                      </li>
                      <ul className="category-sub-menu">
                        {
                          category.children.map((subMenu, j) => {
                            return (
                              <li key={j} className="item">
                                <Link to={`/list-products/${subMenu.id}`} className="item-link">{subMenu.name}</Link>
                              </li>
                            );
                          })
                        }
                      </ul>
                    </ul>
                  );
                }
              })
            }
          </div>
        </div>
        <div className="view-more-category">
          <Link to="/all-categories" className="view-more-link">Hơn 50 danh mục khác</Link>
        </div>
        <span className="toogle-menu-category" onClick={this.toggleCategoryMenu.bind(this)}></span>
      </section>
    );
  }
}

CategoryMenu.defaultProps = {
  categories: [],
  isShowAll: false
};

CategoryMenu.contextTypes = {
  router: PropTypes.object
};

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  };
};

export default connect(bindStateToProps)(withRouter(CategoryMenu));



// WEBPACK FOOTER //
// ./components/category/CategoryMenu.jsx